var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 20.2",
    style: {
      enableBackground: "new 0 0 24 20.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M19.5,14.7c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.3-0.2,0.4-0.4l1.7-1.7v3.8c0,0.5-0.1,1.1-0.3,1.6 c-0.2,0.5-0.5,0.9-0.9,1.3c-0.4,0.4-0.8,0.7-1.3,0.9c-0.5,0.2-1,0.3-1.6,0.3H4c-0.5,0-1.1-0.1-1.6-0.3C2,19.7,1.5,19.4,1.2,19 c-0.4-0.4-0.6-0.8-0.9-1.3c-0.2-0.5-0.3-1-0.3-1.6V4C0,3.5,0.1,3,0.3,2.5C0.5,2,0.8,1.6,1.2,1.2C1.5,0.8,2,0.5,2.4,0.3 C2.9,0.1,3.5,0,4,0h10.9c-0.1,0.3-0.1,0.5-0.1,0.8v0.7c-1.4,0.2-2.7,0.5-4,1H4c-0.4,0-0.8,0.2-1,0.4C2.7,3.3,2.5,3.6,2.5,4v12.1 c0,0.4,0.2,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1,0.4h14c0.8,0,1.5-0.7,1.5-1.5L19.5,14.7L19.5,14.7z M23.7,5.6C23.9,5.8,24,6.1,24,6.4 c0,0.3-0.1,0.6-0.3,0.8l-5.1,5.2c-0.4,0.4-0.7,0.5-0.9,0.4s-0.4-0.4-0.4-0.9V8.4c-1.6,0-3.2,0.2-4.8,0.6c-1.2,0.3-2.4,0.8-3.5,1.5 c-1.8,1.2-2.9,3-3.2,5.1c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.1-0.4-0.3c0,0,0,0,0,0c0-0.2,0-0.4-0.1-0.6v-0.5 c0-1.4,0.2-2.8,0.7-4.1C6.2,9.2,7,8.1,8,7.1c1.1-1,2.4-1.8,3.8-2.3C13.6,4.3,15.4,4,17.3,4V1c0-0.5,0.1-0.8,0.4-0.9s0.5,0,0.9,0.4 L23.7,5.6L23.7,5.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ec369433b666f3bc4bdf6c9f85ddb2b0.svg";
export { ForwardRef as ReactComponent };